var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagsUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dkpg8l2vua)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.048.094h19.809v13H.047z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.048.094h7.987v5.005H.048V.094z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.565 5.1.048 1.736V.094h1.297l6.69 4.077v.928h-2.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.072 5.1.048.818V.094h.307l7.68 4.68v.325h-.963z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.048 13.087h7.987V8.081H.048v5.006z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.565 8.081.048 11.444v1.643h1.297l6.69-4.077v-.929h-2.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.072 8.081-7.024 4.28v.726h.307l7.68-4.68v-.326h-.963z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.857.094H11.87v5.005h7.988V.094z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.34 5.1 5.517-3.363V.094H18.56L11.87 4.17v.928h2.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.833 5.1 19.857.818V.094h-.307l-7.68 4.68v.325h.963z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.857 13.087H11.87V8.081h7.988v5.006z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.34 8.081 5.517 3.363v1.643H18.56L11.87 9.01v-.929h2.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.833 8.081 7.024 4.28v.726h-.307l-7.68-4.68v-.326h.963z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.933.094H7.971v4.66H.048V8.68H7.97v4.415h3.962V8.679h7.924V4.754h-7.924V.094z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.19.094H8.963V5.49H.048v2.208h8.914v5.396h2.229V7.698h8.666V5.49h-8.666V.094z",
    fill: "#FF4B55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dkpg8l2vua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.048 .094)",
    d: "M0 0h19.809v13H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagsUnitedKingdom);
export default __webpack_public_path__ + "static/media/flags-united-kingdom.d294984f3e7c4e3a289ee743596f11b6.svg";
export { ForwardRef as ReactComponent };